var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "moreSearch" },
    [
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: {
            placement: "bottom-start",
            width: "558",
            trigger: "click",
            "popper-class": "my-popover",
          },
          on: { show: _vm.showPopver },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "lyout",
              on: {
                click: function ($event) {
                  _vm.tags = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "cond" },
                [
                  _vm.addButt
                    ? _c("el-button", { on: { click: _vm.addBut } }, [
                        _vm._v("添加筛选条件"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              !_vm.addButt
                ? _c(
                    "div",
                    { staticClass: "main" },
                    [
                      _vm._l(_vm.searchJson, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "main-first" },
                          [
                            _c(
                              "div",
                              { staticClass: "sele-fist" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择",
                                      filterable: "",
                                      remote: "",
                                      "remote-method": function (query) {
                                        _vm.filterMethod(query, item)
                                      },
                                    },
                                    on: {
                                      focus: function ($event) {
                                        return _vm.focusChange(item)
                                      },
                                      change: function ($event) {
                                        return _vm.selectChange(item, $event)
                                      },
                                    },
                                    model: {
                                      value: item.key,
                                      callback: function ($$v) {
                                        _vm.$set(item, "key", $$v)
                                      },
                                      expression: "item.key",
                                    },
                                  },
                                  _vm._l(item.optionsKey, function (key) {
                                    return _c("el-option", {
                                      key: key.prop,
                                      attrs: {
                                        label: key.label,
                                        value: key.prop,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            item.type === "10" ||
                            item.type === "11" ||
                            item.type === "15"
                              ? _c("div", { staticClass: "sele-secon" }, [
                                  item.type === "15"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "input_box",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.labelChange(item.date)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "bottom",
                                                width: "540",
                                                trigger: "click",
                                              },
                                              model: {
                                                value: _vm.tags,
                                                callback: function ($$v) {
                                                  _vm.tags = $$v
                                                },
                                                expression: "tags",
                                              },
                                            },
                                            [
                                              _c("TagsList", {
                                                attrs: {
                                                  "tags-objects":
                                                    _vm.tagsObject,
                                                  "tag-lists": _vm.tagList,
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "input",
                                                  attrs: { slot: "reference" },
                                                  slot: "reference",
                                                },
                                                _vm._l(
                                                  item.labelList,
                                                  function (date, label_user) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: date.id,
                                                        staticStyle: {
                                                          "margin-right": "3px",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              date.labelName
                                                            )
                                                          ),
                                                        ]),
                                                        item.labelList.length -
                                                          1 !=
                                                        label_user
                                                          ? _c("span", [
                                                              _vm._v(","),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  item.type === "10" || item.type === "11"
                                    ? _c("div", { staticClass: "input_box" }, [
                                        _vm.channel === "ding"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "input",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.contactCh(
                                                      item.userList,
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                item.userList,
                                                function (date, user_index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: date.id,
                                                      staticStyle: {
                                                        "margin-right": "3px",
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(date.name)
                                                        ),
                                                      ]),
                                                      item.userList.length -
                                                        1 !=
                                                      user_index
                                                        ? _c("span", [
                                                            _vm._v(","),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "input",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.contactCh(
                                                      item.userList,
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                item.userList,
                                                function (date, user_index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: date.id,
                                                      staticStyle: {
                                                        "margin-right": "3px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        [
                                                          _c("ww-open-data", {
                                                            attrs: {
                                                              type: "userName",
                                                              openid: date.name,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      item.userList.length -
                                                        1 !=
                                                      user_index
                                                        ? _c("span", [
                                                            _vm._v(","),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ])
                              : _c("div", { staticClass: "sele-secon" }, [
                                  item.type === "0"
                                    ? _c("div", [
                                        item.optionsValue.sysFlag === "1"
                                          ? _c("div", [
                                              item.optionsValue.prop ===
                                              "formName"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "222px",
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            multiple: "",
                                                            "collapse-tags": "",
                                                            filterable: "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectChange1(
                                                                item
                                                              )
                                                            },
                                                            focus:
                                                              _vm.getFromList,
                                                          },
                                                          model: {
                                                            value: item.date,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "date",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.date",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.fromList,
                                                          function (value) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: value.id,
                                                                attrs: {
                                                                  label:
                                                                    value.formName,
                                                                  value:
                                                                    value.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : item.optionsValue.prop ===
                                                  "projectName"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "222px",
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            multiple: "",
                                                            "popper-class":
                                                              "selectStyle",
                                                            "collapse-tags": "",
                                                            filterable: "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectChange1(
                                                                item
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value: item.date,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "date",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.date",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.proList,
                                                          function (value) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: value.id,
                                                                attrs: {
                                                                  label:
                                                                    value.proname,
                                                                  value:
                                                                    value.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : item.optionsValue.prop ===
                                                  "flowName"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "222px",
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            multiple: "",
                                                            "collapse-tags": "",
                                                            filterable: "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectChange1(
                                                                item
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value: item.date,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "date",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.date",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.flowList,
                                                          function (value) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: value.id,
                                                                attrs: {
                                                                  label:
                                                                    value.flowName,
                                                                  value:
                                                                    value.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : item.optionsValue.prop ===
                                                  "flowNames"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("el-cascader", {
                                                        staticClass:
                                                          "user-cascader",
                                                        staticStyle: {
                                                          width: "222px",
                                                        },
                                                        attrs: {
                                                          options:
                                                            item.flowList,
                                                          "collapse-tags": "",
                                                          filterable: "",
                                                          props:
                                                            _vm.cascaderProps,
                                                          "popper-class":
                                                            "node",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.selectChange1(
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.date,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "date",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.date",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          autofocus: true,
                                                        },
                                                        model: {
                                                          value: item.value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.value",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                            ])
                                          : item.optionsValue.sysFlag !== "1"
                                          ? _c(
                                              "div",
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "请输入",
                                                    autofocus: true,
                                                  },
                                                  model: {
                                                    value: item.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.value",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                  item.type === "1" || item.type === "16"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "felx",
                                          staticStyle: { display: "flex" },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              placeholder: "最小值",
                                              type: "number",
                                              min: "0",
                                              max: "999999",
                                              autofocus: true,
                                              oninput:
                                                "if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.selectChange1(item)
                                              },
                                            },
                                            model: {
                                              value: item.date[0],
                                              callback: function ($$v) {
                                                _vm.$set(item.date, 0, $$v)
                                              },
                                              expression: "item.date[0]",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "center",
                                              staticStyle: { margin: "0 5px" },
                                            },
                                            [_c("span", [_vm._v("至")])]
                                          ),
                                          _c("el-input", {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              placeholder: "最大值",
                                              type: "number",
                                              autofocus: true,
                                              min: "0",
                                              max: "999999",
                                              oninput:
                                                "if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.selectChange1(item)
                                              },
                                            },
                                            model: {
                                              value: item.date[1],
                                              callback: function ($$v) {
                                                _vm.$set(item.date, 1, $$v)
                                              },
                                              expression: "item.date[1]",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  item.type === "2" ||
                                  item.type === "5" ||
                                  item.type === "12"
                                    ? _c(
                                        "div",
                                        { staticClass: "input-area" },
                                        [
                                          _c("el-input", {
                                            staticStyle: {
                                              height: "36px !important",
                                            },
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入",
                                              autosize: {
                                                minRows: 2,
                                                maxRows: 5,
                                              },
                                              maxlength: "2000",
                                            },
                                            model: {
                                              value: item.value,
                                              callback: function ($$v) {
                                                _vm.$set(item, "value", $$v)
                                              },
                                              expression: "item.value",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  item.type === "4" || item.type === "14"
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: {
                                              width: "222px !important",
                                            },
                                            attrs: {
                                              type: "daterange",
                                              "range-separator": "-",
                                              "start-placeholder": "开始日期",
                                              "end-placeholder": "结束日期",
                                              "value-format": "yyyy/MM/dd",
                                              format: "yyyy/MM/dd",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectChange1(item)
                                              },
                                            },
                                            model: {
                                              value: item.date,
                                              callback: function ($$v) {
                                                _vm.$set(item, "date", $$v)
                                              },
                                              expression: "item.date",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : item.type === "6" || item.type === "8"
                                    ? _c("div", [
                                        item.optionsValue.sysFlag === "1" &&
                                        _vm.tabType !== "4"
                                          ? _c("div", [
                                              item.optionsValue.prop ===
                                              "status"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            multiple: "",
                                                            "collapse-tags": "",
                                                            filterable: "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectChange1(
                                                                item
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value: item.date,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "date",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.date",
                                                          },
                                                        },
                                                        _vm._l(
                                                          item.optionsValue
                                                            .options,
                                                          function (group) {
                                                            return _c(
                                                              "el-option-group",
                                                              {
                                                                key: group.label,
                                                                attrs: {
                                                                  label:
                                                                    group.label,
                                                                },
                                                              },
                                                              _vm._l(
                                                                group.options,
                                                                function (
                                                                  item1
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: item1.value,
                                                                      attrs: {
                                                                        label:
                                                                          item1.label,
                                                                        value:
                                                                          item1.value,
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            multiple: "",
                                                            "collapse-tags": "",
                                                            filterable: "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectChange1(
                                                                item
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value: item.date,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "date",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.date",
                                                          },
                                                        },
                                                        _vm._l(
                                                          item.optionsValue
                                                            .options,
                                                          function (value) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: value.key,
                                                                attrs: {
                                                                  label:
                                                                    value.name,
                                                                  value:
                                                                    value.key,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ])
                                          : item.optionsValue.sysFlag === "1" &&
                                            _vm.tabType == "4"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "请选择",
                                                      multiple: "",
                                                      "collapse-tags": "",
                                                      filterable: "",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.selectChange1(
                                                          item
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: item.date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "date",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.date",
                                                    },
                                                  },
                                                  _vm._l(
                                                    item.optionsValue.options,
                                                    function (value) {
                                                      return _c("el-option", {
                                                        key: value.key,
                                                        attrs: {
                                                          label: value.name,
                                                          value: value.key,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "请选择",
                                                      "popper-class":
                                                        "selectStyle",
                                                      multiple: "",
                                                      "collapse-tags": "",
                                                      filterable: "",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.selectChange1(
                                                          item
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: item.date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "date",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.date",
                                                    },
                                                  },
                                                  _vm._l(
                                                    item.optionsValue.options,
                                                    function (value) {
                                                      return _c("el-option", {
                                                        key: value.key,
                                                        attrs: {
                                                          label: value.value,
                                                          value: value.key,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                      ])
                                    : _vm._e(),
                                  item.type === "7" || item.type === "9"
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder: "请选择",
                                                "popper-class": "selectStyle",
                                                multiple: "",
                                                "collapse-tags": "",
                                                filterable: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.selectChange1(item)
                                                },
                                              },
                                              model: {
                                                value: item.date,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "date", $$v)
                                                },
                                                expression: "item.date",
                                              },
                                            },
                                            _vm._l(
                                              item.optionsValue.options,
                                              function (value) {
                                                return _c("el-option", {
                                                  key: value.key,
                                                  attrs: {
                                                    label: value.value,
                                                    value: value.key,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : !item.type
                                    ? _c("div", [
                                        _c("div", { staticClass: "input_box" }),
                                      ])
                                    : _vm._e(),
                                ]),
                            _c("div", { staticClass: "sele-icon" }, [
                              _c("i", {
                                staticClass: "iconfont icon-checkbox-minus",
                                on: {
                                  click: function ($event) {
                                    return _vm.delCond(index)
                                  },
                                },
                              }),
                              _c("i", {
                                staticClass: "iconfont icon-checkbox-plus",
                                on: { click: _vm.addCond },
                              }),
                            ]),
                          ]
                        )
                      }),
                      !_vm.addButt
                        ? _c("div", { staticClass: "footer" }, [
                            _c(
                              "div",
                              [
                                _c("el-button", { on: { click: _vm.reset } }, [
                                  _vm._v("清空"),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.screening },
                                  },
                                  [_vm._v("确定")]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "more_btn",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: _vm.addButt ? "info" : "primary", plain: "" },
                },
                [
                  _c("i", {
                    staticClass: "iconfont icon-shaixuan-",
                    staticStyle: { "font-size": "16px" },
                  }),
                  _c("span", [_vm._v(" 更多筛选 ")]),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }